import debug from 'debug';
import DateHelper from 'Minetilbud/Shared/Components/Date/DateHelper';
import basketOutlineSvg from 'Minetilbud/Shared/Icons/icon_online_buy.svg';

const date = new DateHelper();
const log = debug('InspirationCatalogsByQuery:Templates');

class Template {
	getCustomerLink(catalog) {
		if (catalog.customerUrl) {
			return `<a href="${ catalog.customerUrl }" class="o-inspiration-catalogs__customer-link">${ catalog.customerName }</a>`;
		} else {
			return `<span class="o-inspiration-catalogs__name">${ catalog.customerName }</span>`;
		}
		
	}

	getImage(imageUrl, altText) {
		const scale = window.devicePixelRatio;
		const url = imageUrl.replace('{maxwidth}', (136 * scale)).replace('{maxheight}', (180 * scale));

		return `<img class="o-inspiration-catalogs__cover" width="136" height="180" src="${url}" alt="${altText}" />`;
	}

	getShopIcon(catalog) {
		if (catalog.hasLinks) {
			return `<span class="o-inspiration-catalogs__shop-icon">${ basketOutlineSvg }</span>`;
		}
		else {
			return ``;
		}
	}

	getValidToDate(catalog) {
		if (!catalog.validTo || catalog.showDate === false) {
			return '';
		}

		return `<span class="o-inspiration-catalogs__description">${ date.Format(catalog.validFrom) }-${ date.Format(catalog.validTo) }</span>`;
	}

	/**
	 * @param {Object} catalog 
	 */
	listItem(catalog) {
		return `
			<li class="o-inspiration-catalogs__item">
				<a class="o-inspiration-catalogs__image" href="${ catalog.catalogUrl }">
					${this.getImage(catalog.frontPageImageUrl, catalog.customerName)}
				</a>
				${ this.getShopIcon(catalog) }
				${ this.getValidToDate(catalog) }
				${ this.getCustomerLink(catalog) }
			</li>
		`;
	}
}

export default Template;
